import { Pipe, PipeTransform } from "@angular/core";
import { AnyAbility } from "@casl/ability";
import { AblePurePipe } from "@casl/angular";

@Pipe({
    name: "isAblePure",
    standalone: false
})
export class IsAblePurePipe<T extends AnyAbility>
  extends AblePurePipe<T>
  implements PipeTransform {}
